import { defineField, defineType } from 'sanity'
import getPageInfo, { seoGroup } from '../objects/pageInfo'
import { PageBlockTypes } from '../pageBlocks'

export default defineType({
  name: 'constructionType',
  title: 'Construction Types',
  type: 'document',
  orderings: [
    {
      title: 'Name A-Z',
      name: 'nameAsc',
      by: [{field: 'name', direction: 'asc'}],
    },
  ],
  groups: [
    {
      name: 'content',
      title: 'Content',
      default: true,
    },
    seoGroup,
  ],
  fields: [
    defineField({
      title: 'Hero',
      name: 'hero',
      type: 'hero',
      group: 'content',
    }),
    defineField({
      title: 'Name',
      name: 'name',
      type: 'string',
      group: 'content',
    }),
    defineField({
      name: 'about',
      title: 'About',
      type: 'richText',
      group: 'content',
      description: 'This text will appear at the top of the page',
    }),
    defineField({
      ...getPageInfo({ path: 'constructionType' }),
    }),
    defineField({
      title: 'Page blocks',
      name: 'pageBlocks',
      type: 'array',
      of: [...PageBlockTypes],
      group: 'content',
    }),
  ],
  preview: {
    select: {
      name: 'pageInfo.title',
    },
    prepare({ name: title = 'New page' }) {
      return { title }
    },
  },
})